import { mainColor } from "../../constants/colors";
import "../../index.css";

export function ProgressBar() {
  return (
    <div className="progress-loader">
      <div className="progress" style={{ background: mainColor }}></div>
    </div>
  );
}
